import { chat, room } from "../../libs/roomnew";
import { findChatById, renderChatHeader, renderChatsList } from "./chatsList";

export function getChatsList() {

}

export function getAvailableParticipantsToChat(filter = "") {
        const participants = chat.getParticipantIds().filter((pId) => {
          return (
            chat.getParticipantDisplayName(pId)
              .toLowerCase()
              .search(filter.toLowerCase()) > -1);
        });
        return participants
          .filter((pId) => !chat.selectedParticipantsToMessage.includes(pId));
}

export const  createGroupChatFromMenu = (participants) => {
    return new Promise(async (resolve, reject) => {
        let group_id = chat.getGroupId(participants.map((p) => p.guest_id));
        if (!group_id) {

            await chat.createGroup(participants,true)
              .then(async (res) => {
                await chat.createLocalGroup(res.data);
                group_id = res.data.id;
                chat.selectedChatId = group_id;
                chat.lastSelectedChatId = group_id;
                chat.sendGroupIdChanged(group_id);
                const newChat = findChatById(group_id);
                chat.setChatselected(newChat)
                broadcastNewGroupCreated(group_id)
                resolve(newChat);
              })
              .catch((err) => {
                reject(err);
              });
        }else{
            const newChat = findChatById(group_id);
            chat.setChatselected(newChat)
            resolve(newChat);
        }
    })

}

export const addMembersFromMenu = (group_id,members) => {
    return new Promise(async (resolve, reject) => {
        chat.addGroupMembers(group_id,members)
          .then(async (group) => {
            chat.updateLocalGroupMembers(group_id,group.members);
            renderChatsList();
            renderChatHeader();
            broadcastNewGroupCreated(group_id)
            resolve(group);
          })
          .catch((err) => {
            reject(err);
          });
    })

}

export const broadcastNewGroupCreated=(group_id) => {
    try {
        const group = chat.getGroupChatById(group_id);
        room.broadcastEndpointMessage({
            chat_message: "group_created",
            group: group,
          });

    } catch (error) {

    }
}
